import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { ContentTag, connect } from "scrivito"
import { PortalNewsPostObj } from "scrivito/Objs/PortalNewsPost/PortalNewsPostObjClass"
import { getFormattingLocale } from "shared/lib/locale/formattingLocale"

import { ParseKeys } from "i18next"

import { PortalNewsListItem } from "./PortalNewsListItem"

interface ScrivitoPortalNewsListItemProps {
  post?: PortalNewsPostObj
  maxPostAgeInDays?: number | null | undefined
  isUnread?: boolean
}

function ScrivitoPortalNewsListItemComponent({
  post,
  maxPostAgeInDays,
  isUnread
}: ScrivitoPortalNewsListItemProps) {
  const { t } = useTranslation()

  const postDate = post?.get("date") ?? null

  const isOutdated = useMemo(() => {
    if (!maxPostAgeInDays || !postDate) {
      return false
    }
    const maxAgeDate = new Date()
    maxAgeDate.setDate(new Date().getDate() - (maxPostAgeInDays ?? 0))
    return maxAgeDate.getTime() > postDate.getTime()
  }, [maxPostAgeInDays])

  const isUpcoming = useMemo(() => {
    if (!postDate) {
      return false
    }
    return new Date().getTime() < postDate.getTime()
  }, [maxPostAgeInDays])

  if (!post) {
    return null
  }

  return (
    <PortalNewsListItem
      title={<ContentTag content={post} attribute="title" />}
      portalVersion={
        <ContentTag
          content={post}
          attribute="portalVersion"
          renderEmptyAttribute={false}
        />
      }
      text={<ContentTag content={post} attribute="text" />}
      media={
        <ContentTag
          content={post}
          attribute="media"
          renderEmptyAttribute={false}
        />
      }
      date={post.get("date")?.toLocaleDateString(getFormattingLocale())}
      category={
        post.get("category")
          ? (t(
              `PortalNewsPost.Category.${post.get("category")}` as ParseKeys
            ) as string)
          : null
      }
      isOutdated={isOutdated}
      isUpcoming={isUpcoming}
      isUnread={isUnread}
    />
  )
}

export const ScrivitoPortalNewsListItem = React.memo(
  connect(ScrivitoPortalNewsListItemComponent)
)
